<template>
  <div class="login-wrapper">
    <div class="login-card">
      <h1 class="title">Docker配信システム</h1>
      <h2 class="subtitle">管理者ログイン</h2>

      <form @submit.prevent="handleLogin">
        <div class="form-group">
          <label for="username">管理者ID</label>
          <input
            id="username"
            v-model="username"
            type="text"
            placeholder="管理者ID"
            required
          />
        </div>
        <div class="form-group">
          <label for="password">パスワード</label>
          <input
            id="password"
            v-model="password"
            type="password"
            placeholder="パスワード"
            required
          />
        </div>
        <p v-if="errorMsg" class="error-msg">{{ errorMsg }}</p>
        <button type="submit" class="btn btn-primary" :disabled="loading">
          {{ loading ? 'ログイン中...' : 'ログイン' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import api from '../api.js';

export default {
  name: 'LoginView',
  data() {
    return {
      username: '',
      password: '',
      errorMsg: '',
      loading: false,
    };
  },
  methods: {
    async handleLogin() {
      this.errorMsg = '';
      this.loading = true;
      try {
        await api.post('/api/admin/login', {
          username: this.username,
          password: this.password,
        });
        this.$router.push('/menu');
      } catch (err) {
        this.errorMsg = err.response?.data?.error || 'ログインに失敗しました';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.login-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #f0f2f5;
}
.login-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 48px 40px;
  width: 360px;
}
.title {
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 4px;
}
.subtitle {
  font-size: 14px;
  color: #57606a;
  text-align: center;
  margin-bottom: 32px;
}
.form-group {
  margin-bottom: 16px;
}
.form-group label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
}
.form-group input {
  width: 100%;
  padding: 9px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
}
.form-group input:focus {
  border-color: #3b82d4;
}
.error-msg {
  color: #d73a49;
  font-size: 13px;
  margin-bottom: 12px;
}
.btn {
  width: 100%;
  padding: 10px;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  cursor: pointer;
}
.btn-primary {
  background: #3b82d4;
  color: #fff;
  font-weight: 600;
}
.btn-primary:hover:not(:disabled) {
  background: #2f6bbf;
}
.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
